// extracted by mini-css-extract-plugin
export default {"panelWrapper":"ActivityTypeEditComponent_panelWrapper__vFsp-"};